export const ChatContextInteractionSubmit = 'chatContextInteractionSubmit';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat-context-interaction/models/events.ts